const ALIASES = { "/dashboard": "/", "/orders": "/dispatch", "/batching": "/batcher", "/planner": "/dispatch" };
const ALWAYS = ["/system-logs", "/organizations", "/support-inbox"];

export const canAccess = (user, path) => {
  if (!user) return false;
  if (user.role === "admin" || user.is_super_admin) return true;
  const p = ALIASES[path] || path;
  if (ALWAYS.includes(p)) return false;
  return (user.pages || []).includes(p);
};

export const homeFor = (user) => {
  if (!user) return "/login";
  if (user.role === "driver") return "/driver";
  if (user.role === "loader") return "/loader";
  const pages = user.pages || [];
  if (user.role === "admin" || pages.includes("/")) return "/";
  return pages[0] || "/";
};
